// StatementsStatsCards.tsx — Sprint 13. Four metric cards across the
// top of the table (Total / Sent / Draft / Total Balance). Stateless.
import React from 'react';
import { Card, Col, Row } from 'antd';
import {
  CheckCircleOutlined, ClockCircleOutlined, DollarOutlined, FileTextOutlined,
} from '@ant-design/icons';
import { currency } from '../../utils/currency';

export interface StatementsStatsCardsProps {
  count:        number;
  sentCount:    number;
  draftCount:   number;
  totalBalance: number;
}

export const StatementsStatsCards: React.FC<StatementsStatsCardsProps> = ({
  count, sentCount, draftCount, totalBalance,
}) => {
  const cards = [
    { label: 'Total Statements',  value: count,                                                      icon: <FileTextOutlined />,    color: '#4f46e5',                          bg: '#eef2ff' },
    { label: 'Sent',              value: sentCount,                                                  icon: <CheckCircleOutlined />, color: '#059669',                          bg: '#ecfdf5' },
    { label: 'Pending / Draft',   value: draftCount,                                                 icon: <ClockCircleOutlined />, color: draftCount   > 0 ? '#d97706' : '#059669', bg: draftCount   > 0 ? '#fffbeb' : '#ecfdf5' },
    // Sprint 146 (ADR-141, R14-11) — this was a hand-rolled dollar-sign plus
    // fixed-decimal template, which rendered 1900 dollars with no thousands
    // separator. All money goes through the en-CA currency() helper; the CI
    // guard now fails that form. (Deliberately described in prose, not quoted —
    // quoting the pattern would trip the guard on this very comment.)
    { label: 'Total Balance Due', value: currency(totalBalance),                                     icon: <DollarOutlined />,      color: totalBalance > 0 ? '#dc2626' : '#059669', bg: totalBalance > 0 ? '#fef2f2' : '#ecfdf5' },
  ];

  return (
    <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
      {cards.map((m, i) => (
        <Col key={i} xs={24} sm={12} md={6}>
          <Card
            size="small"
            style={{
              borderRadius: 10,
              border: '1px solid #e5e7eb',
              overflow: 'hidden',
              boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
            }}
            bodyStyle={{ padding: 0 }}
          >
            <div style={{ height: 4, background: m.color, borderRadius: '10px 10px 0 0' }} />
            <div style={{ padding: '16px 20px', background: m.bg }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{
                  width: 36, height: 36, borderRadius: 8,
                  background: '#fff',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                  color: m.color, fontSize: 16,
                }}>
                  {m.icon}
                </div>
                <div>
                  <div style={{ fontSize: 11, color: '#6b7280', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    {m.label}
                  </div>
                  <div style={{ fontSize: 22, fontWeight: 700, color: m.color, lineHeight: 1.2 }}>
                    {typeof m.value === 'string' ? m.value : m.value.toLocaleString()}
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
};
